<template>
  <div class="foot">
    <!-- 页尾 / Start -->
    <div class="m-footer" module="menu-footer">
      <div class="footer-feature g-wrapper">
        <div class="feature-item">
          <img src="../assets/picture/icon_footer_1.png" class="icon" />
          <div class="info">
            <p class="tit">品类齐全</p>
            <p>省心省力，一站购齐</p>
          </div>
        </div>
        <div class="feature-item">
          <img src="../assets//picture/icon_footer_2.png" class="icon" />
          <div class="info">
            <p class="tit">一对一客服</p>
            <p>选型询价，快速响应</p>
          </div>
        </div>
        <div class="feature-item">
          <img src="../assets//picture/icon_footer_3.png" class="icon" />
          <div class="info">
            <p class="tit">货期保障</p>
            <p>多仓直发，货期无忧</p>
          </div>
        </div>
        <div class="feature-item">
          <img src="../assets//picture/icon_footer_4.png" class="icon" />
          <div class="info">
            <p class="tit">正品货源</p>
            <p>正品保障，诚信服务</p>
          </div>
        </div>
      </div>

      <div class="footer-menu g-wrapper g-clearfix">
        <ul class="menu-list g-clearfix">
          <li class="menu-item">
            <a href="javascript:void(0)" class="menu-title">购物指南</a>
            <div class="sub-list">
              <a href="/help?path=shopstep_0_0" target="_blank">购物流程</a>
              <a href="javascript:void(0)">支付方式</a>
              <a href="javascript:void(0)">常见问题</a>
            </div>
          </li>
          <li class="menu-item">
            <a href="/help?path=explans_1_0" class="menu-title" target="_blank">配送政策</a>
            <div class="sub-list">
              <a href="/help?path=explans_1_0" target="_blank">配送说明</a>
              <a href="/help?path=notice_1_1" target="_blank">配送须知</a>
              <a href="/help?path=sign_1_2" target="_blank">验货签收</a>
              <a href="/help?path=answer_1_3" target="_blank">配送答疑</a>
            </div>
          </li>
          <li class="menu-item">
            <a href="/help?path=range_2_0" class="menu-title">售后服务</a>
            <div class="sub-list">
              <a href="/help?path=range_2_0">退换货范围</a>
              <a href="/help?path=rule_2_1">退换货细则</a>
              <a href="/help?path=refundment_2_2">退款说明</a>
              <a href="/help?path=way_2_3">售后联系方式</a>
            </div>
          </li>
          <!-- <li class="menu-item">
            <a href="javascript:void(0)" class="menu-title">关于我们</a>
            <div class="sub-list">
              <a href="http://www.cesseon.com/" target="_blank">公司介绍</a>
              <a href="contact" target="_blank">联系方式</a>
              <a href="http://www.cesseon.com/" target="_blank">加入我们</a>
            </div>
          </li>-->
        </ul>
        <div class="footer-contact">
          <div class="item contact">
            <p class="tit">400-665-8016</p>
            <p>传真：0512-53109060</p>
          </div>
          <div class="item worktime">
            <p class="tit">工作时间</p>
            <p>周一到周六 8:30-17:30</p>
          </div>
        </div>
        <!-- <div class="footer-qrcode">
          <a
            href="tencent://message/?Menu=yes&uin=2850689472&Site=工品汇&Service=300&sigT=12a1e5847943b64c6ff3990f8a9e644d2b31356cb0b4ac6b24663a3c8dd0f8aa12a595b1714f9d45"
            target="_blank"
          >
            <img src="../assets//picture/pic_footer_qrcode.png">
          </a>
        </div>-->
      </div>
    </div>
    <!-- 页尾 / End -->

    <!-- 底部 / Start -->
    <div class="m-bottom">
      <div class="g-wrapper">
        <div class="bottom-info">
          Copyright© 2019-
          <i class="endYear" style="font-style:normal" id="copyrightEndYear"></i> 版权所有
          <a href="http://www.cesseon.com/" target="_blank">西始工业超市</a>
          <!-- <a
            href="/../assets//images/b2-20140259.jpg"
            target="_blank"
            rel="nofollow"
          >苏ICP证B2-201402593</a>
          <a href="http://www.miitbeian.gov.cn" target="_blank" rel="nofollow">苏ICP备12073768号-3</a>
          <a target="_blank" href="/sitemap">网站地图</a>
          <a href="/../assets//images/license.png" target="_blank" rel="nofollow">工商执照</a>-->
        </div>
        <div class="bottom-flinks" module="friendly-links">
          <div class="flinks-title">友情链接：</div>
          <div class="flinks-list">
            <a href="https://new.abb.com/cn" title="ABB官网" target="_blank" rel="nofollow">ABB官网</a>
            <a
              href="https://www.schneider-electric.cn/zh/"
              title="施耐德官网"
              target="_blank"
              rel="nofollow"
            >施耐德官网</a>
            <a
              href="https://www.siemens.com/cn/zh/home.html"
              title="西门子官网"
              target="_blank"
              rel="nofollow"
            >西门子官网</a>
            <a href="http://www.delixi.com/" title="德力西官网" target="_blank" rel="nofollow">德力西官网</a>
            <a
              href="https://www.fa.omron.com.cn/"
              title="欧姆龙官网"
              target="_blank"
              rel="nofollow"
            >欧姆龙官网</a>
            <a
              href="https://www.festo.com.cn/cms/zh-cn_cn/index.htm"
              title="费斯托官网"
              target="_blank"
              rel="nofollow"
            >费斯托官网</a>
            <a href="http://www.smc.com.cn/zh/" title="SMC官网" target="_blank" rel="nofollow">SMC官网</a>
            <a href="http://www.airtac.com/" title="亚德客官网" target="_blank" rel="nofollow">亚德客官网</a>
            <a
              href="https://www.3m.com.cn/3M/zh_CN/company-cn/?utm_medium=redirect&utm_source=vanity-url&utm_campaign=www.3m.com.cn/"
              title="3M官网"
              target="_blank"
              rel="nofollow"
            >3M官网</a>
            <a
              href="https://www.deltaplus.com.cn/zh/"
              title="代尔塔官网"
              target="_blank"
              rel="nofollow"
            >代尔塔官网</a>
            <a
              href="https://www.honeywell.com.cn/"
              title="霍尼韦尔官网"
              target="_blank"
              rel="nofollow"
            >霍尼韦尔官网</a>
            <a href="http://cn.msasafety.com/" title="梅斯安官网" target="_blank" rel="nofollow">梅斯安官网</a>
            <a href="http://www.satatools.com/" title="世达工具官网" target="_blank" rel="nofollow">世达工具官网</a>
            <a href="https://www.bosch.com.cn/" title="博世工具官网" target="_blank" rel="nofollow">博世工具官网</a>
            <a href="http://www.3mfangdumianju.cn" title="防毒面具" target="_blank">防毒面具</a>
            <a href="http://www.kuo9.com/" title="办公家具" target="_blank">办公家具</a>
            <a href="http://www.sz1c.com/" title="PET膜" target="_blank">PET膜</a>
            <a href="https://www.gmb2b.com/" title="免费B2B电商网站" target="_blank">免费B2B电商网站</a>
            <a href="http://www.1688ru.com/" title="1688批发网" target="_blank">1688批发网</a>
            <a href="http://www.kcwujin.com/" title="五金冲压件" target="_blank">五金冲压件</a>
            <a href="http://bianpinqi.gkzhan.com/" title="变频器网" target="_blank">变频器网</a>
            <a href="https://www.gkzhan.com/" title="中国智能制造网" target="_blank">中国智能制造网</a>
            <a href="http://www.cnzyjc.com/" title="冲剪机" target="_blank">冲剪机</a>
            <a href="http://www.huajx.com/" title="中国化工机械设备网" target="_blank">中国化工机械设备网</a>
            <a href="https://www.sogaa.net/" title="零件加工" target="_blank">零件加工</a>
            <a href="https://www.3qled.com/ " title="显示之家" target="_blank">显示之家</a>
            <a href="http://www.mro365.com/" title="劳保用品" target="_blank">劳保用品</a>
            <a href="http://www.maihengqi.com/" title="电子秤" target="_blank">电子秤</a>
            <a href="http://www.kowloonjq.com" title="削片机" target="_blank">削片机</a>
            <a href="http://www.86pla.com/" title="中国塑料机械网" target="_blank">中国塑料机械网</a>
          </div>
        </div>
        <!-- <div class="bottom-cert">
          <a target="_blank">
            <img src="../assets//picture/cert.png">
          </a>
          <a class="ebs">
            <img src="../assets//picture/icon_ebs.png">
          </a>
        </div>-->
      </div>
    </div>
    <!-- 底部 / End -->
  </div>
</template>

<script>
export default {
  name: "global-foot"
};
</script>

<style>
</style>
